import qs from 'qs';

import { IAuthResponse } from '@interfaces/auth';
import { getRefreshTokenFromLocalStorage } from '@utils/token';

import { apiUrls, clientId, redirectUrl } from './urls';
import { postToken } from './utils';

export const login = (authorizationCode: string) =>
  postToken<IAuthResponse>(
    apiUrls.oauth2.token,
    qs.stringify({
      grant_type: 'authorization_code',
      code: authorizationCode,
      redirect_uri: redirectUrl,
      client_id: clientId,
    }),
  );

export const refreshToken = () =>
  postToken<IAuthResponse>(
    apiUrls.oauth2.token,
    qs.stringify({
      grant_type: 'refresh_token',
      refresh_token: getRefreshTokenFromLocalStorage(),
      client_id: clientId,
    }),
  );
